import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form,
      labelAlign: "left"
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("出单方式")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("出单方式"),
      allowClear: ""
    },
    model: {
      value: _vm.form.isTimely,
      callback: function ($$v) {
        _vm.$set(_vm.form, "isTimely", $$v);
      },
      expression: "form.isTimely"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("非实时出单")))]), _c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("实时出单")))])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("保单状态")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("保单状态"),
      allowClear: ""
    },
    model: {
      value: _vm.form.status,
      callback: function ($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("待投保")))]), _c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("待生效")))]), _c("a-select-option", {
    attrs: {
      value: 2
    }
  }, [_vm._v(_vm._s(_vm.$t("保障中")))]), _c("a-select-option", {
    attrs: {
      value: 3
    }
  }, [_vm._v(_vm._s(_vm.$t("已过期")))]), _c("a-select-option", {
    attrs: {
      value: 4
    }
  }, [_vm._v(_vm._s(_vm.$t("退保中")))]), _c("a-select-option", {
    attrs: {
      value: 5
    }
  }, [_vm._v(_vm._s(_vm.$t("已退保")))]), _c("a-select-option", {
    attrs: {
      value: 6
    }
  }, [_vm._v(_vm._s(_vm.$t("退保失败")))])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    staticStyle: {
      display: "flex"
    },
    attrs: {
      label: _vm.$t("精准查询")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("类型"),
      allowClear: ""
    },
    on: {
      change: function ($event) {
        _vm.form.content = "";
      }
    },
    model: {
      value: _vm.form.search,
      callback: function ($$v) {
        _vm.$set(_vm.form, "search", $$v);
      },
      expression: "form.search"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("用户名")))]), _c("a-select-option", {
    attrs: {
      value: 2
    }
  }, [_vm._v(_vm._s(_vm.$t("保单号")))]), _c("a-select-option", {
    attrs: {
      value: 3
    }
  }, [_vm._v(_vm._s(_vm.$t("订单号")))]), _c("a-select-option", {
    attrs: {
      value: 4
    }
  }, [_vm._v(_vm._s(_vm.$t("投保人")))]), _c("a-select-option", {
    attrs: {
      value: 5
    }
  }, [_vm._v(_vm._s(_vm.$t("投保人证件号")))]), _c("a-select-option", {
    attrs: {
      value: 6
    }
  }, [_vm._v(_vm._s(_vm.$t("被保人")))]), _c("a-select-option", {
    attrs: {
      value: 7
    }
  }, [_vm._v(_vm._s(_vm.$t("被保人证件号")))])], 1), _c("a-input", {
    staticStyle: {
      "margin-left": "10px",
      width: "170px"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("内容"),
      allowClear: "",
      disabled: _vm.form.search ? false : true
    },
    model: {
      value: _vm.form.content,
      callback: function ($$v) {
        _vm.$set(_vm.form, "content", $$v);
      },
      expression: "form.content"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("投保时间")
    }
  }, [_c("datePicker", {
    ref: "applicationTime",
    on: {
      change: _vm.onChangeTime
    }
  })], 1)], 1), this.accountInfo.tag != 0 ? _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("保单归属")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("保单归属"),
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption2
    },
    on: {
      change: _vm.customerChange
    },
    model: {
      value: _vm.form.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerId", $$v);
      },
      expression: "form.customerId"
    }
  }, _vm._l(_vm.customerList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "top",
        title: item.name
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1);
  }), 1)], 1)], 1) : _vm._e(), _vm.showItem ? _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("订单状态")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("订单状态"),
      allowClear: ""
    },
    model: {
      value: _vm.form.payStatusName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "payStatusName", $$v);
      },
      expression: "form.payStatusName"
    }
  }, _vm._l(_vm.PAYSTATUS, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(_vm._s(_vm.$t(item.value)))]);
  }), 1)], 1)], 1) : _vm._e(), _vm.showItem ? _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("保单来源")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("保单来源"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption
    },
    on: {
      change: _vm.getInsuranceFun
    },
    model: {
      value: _vm.form.applicationId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "applicationId", $$v);
      },
      expression: "form.applicationId"
    }
  }, _vm._l(_vm.applicationList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.applicationId
      }
    }, [_vm._v(_vm._s(item.name) + "(" + _vm._s(item.type == 1 ? "app" : item.type == 2 ? "h5" : item.type == 3 ? "pc" : _vm.$t("小程序")) + ")")]);
  }), 1)], 1)], 1) : _vm._e(), _vm.showItem ? _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("产品名称")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("产品"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption,
      disabled: _vm.form.applicationId ? false : true
    },
    model: {
      value: _vm.form.insuranceId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "insuranceId", $$v);
      },
      expression: "form.insuranceId"
    }
  }, _vm._l(_vm.productList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1) : _vm._e(), _vm.accountInfo.tag !== 1 && _vm.showItem ? _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("承保机构")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("机构"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption2
    },
    model: {
      value: _vm.form.agencyId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "agencyId", $$v);
      },
      expression: "form.agencyId"
    }
  }, _vm._l(_vm.intermediaryList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "top",
        title: item.name
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1);
  }), 1)], 1)], 1) : _vm._e(), _vm.showItem ? _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("区域")
    }
  }, [_c("a-cascader", {
    attrs: {
      options: _vm.rearOptions,
      placeholder: _vm.$t("请选择")
    },
    on: {
      change: _vm.areaChange
    },
    model: {
      value: _vm.areaValue,
      callback: function ($$v) {
        _vm.areaValue = $$v;
      },
      expression: "areaValue"
    }
  })], 1)], 1) : _vm._e(), _vm.showItem ? _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("录单方式")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("录单方式"),
      allowClear: ""
    },
    model: {
      value: _vm.form.recordMethod,
      callback: function ($$v) {
        _vm.$set(_vm.form, "recordMethod", $$v);
      },
      expression: "form.recordMethod"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "0"
    }
  }, [_vm._v(_vm._s(_vm.$t("线上出单")))]), _c("a-select-option", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("手动录单")))]), _c("a-select-option", {
    attrs: {
      value: "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("线下出单")))])], 1)], 1)], 1) : _vm._e(), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_vm.tagData.length != 0 ? _c("a-button", {
    attrs: {
      type: "linkSeach"
    },
    on: {
      click: function ($event) {
        _vm.tagShow = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("标签查询")))]) : _vm._e(), _c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        _vm.showItem = !_vm.showItem;
      }
    }
  }, [_vm._v(_vm._s(_vm.showItem ? _vm.$t("收起查询条件") : _vm.$t("更多查询条件")))])], 1)], 1), _vm.tagList.length != 0 ? _c("a-row", [_c("a-form-item", {
    staticClass: "tagBox",
    attrs: {
      label: _vm.$t("已选择标签")
    }
  }, [_c("tag-list", {
    attrs: {
      tagList: _vm.tagList,
      tagData: _vm.tagData,
      format: "second"
    },
    on: {
      ok: _vm.tagListOk
    }
  })], 1)], 1) : _vm._e(), _c("div", {
    staticClass: "marginT10"
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))]), _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "edit"
    },
    on: {
      click: _vm.resetFun
    }
  }, [_vm._v(_vm._s(_vm.$t("重置")))]), _vm.isAuth("customer.policyExport") ? _c("a-button", {
    staticClass: "marginR15",
    on: {
      click: _vm.downloadFun
    }
  }, [_vm._v(_vm._s(_vm.$t("导出")))]) : _vm._e(), _vm.isAuth("customer.policyStore") ? _c("a-button", {
    staticClass: "select-bottom",
    attrs: {
      type: "add",
      icon: "plus"
    },
    on: {
      click: function ($event) {
        return _vm.$router.push({
          name: "customerAddPolicyInfo"
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("录入保单")))]) : _vm._e()], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      align: "center",
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "tag",
      fn: function (text, record) {
        return [_c("click-show-tag", {
          attrs: {
            data: record.tagsData
          }
        }, [_c("span", {
          attrs: {
            slot: "icon"
          },
          slot: "icon"
        }, [_c("a-icon", {
          attrs: {
            type: "switcher"
          }
        })], 1)])];
      }
    }, {
      key: "status",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(text == 0 ? _vm.$t("待投保") : text == 1 ? _vm.$t("待生效") : text == 2 ? _vm.$t("保障中") : text == 3 ? _vm.$t("已过期") : text == 4 ? _vm.$t("退保中") : text == 5 ? _vm.$t("已退保") : text == 6 ? _vm.$t("退保失败") : "") + " ")];
      }
    }, {
      key: "unitName",
      fn: function (text, record) {
        return [_c("a-tooltip", {
          attrs: {
            placement: "topLeft",
            title: record.unitName
          }
        }, [_vm._v(_vm._s(record.unitName))])];
      }
    }, {
      key: "action",
      fn: function (text, record, index) {
        return [_vm.isAuth("customer.policyDetail") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "customerPolicy",
                params: {
                  id: record.policyId
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("查看")))]) : _vm._e(), _c("a-dropdown", {
          scopedSlots: _vm._u([{
            key: "overlay",
            fn: function () {
              return [_c("a-menu", [_vm.isAuth("customer.policyEdit") ? _c("a-menu-item", [_c("a-button", {
                attrs: {
                  type: "edit",
                  size: "small"
                },
                on: {
                  click: function ($event) {
                    return _vm.editPolicy(index);
                  }
                }
              }, [_vm._v("编辑")])], 1) : _vm._e(), _vm.isAuth("customer.policyZip") ? _c("a-menu-item", [_c("a-button", {
                attrs: {
                  size: "small"
                },
                on: {
                  click: function ($event) {
                    return _vm.handleDownload(record);
                  }
                }
              }, [_vm._v(_vm._s(_vm.$t("下载保单")))])], 1) : _vm._e(), _vm.isAuth("customer.correctRecordList") ? _c("a-menu-item", [_c("a-button", {
                attrs: {
                  size: "small",
                  type: "primary2"
                },
                on: {
                  click: function ($event) {
                    return _vm.toCorrectionRecord(record);
                  }
                }
              }, [_vm._v(_vm._s(_vm.$t("批改记录")))])], 1) : _vm._e(), _vm.isAuth("customer.personnelDetailsList") ? _c("a-menu-item", [_c("a-button", {
                attrs: {
                  size: "small",
                  type: "primary2"
                },
                on: {
                  click: function ($event) {
                    return _vm.toPersonnelDetail(record);
                  }
                }
              }, [_vm._v(_vm._s(_vm.$t("人员明细")))])], 1) : _vm._e()], 1)];
            },
            proxy: true
          }], null, true)
        }, [_vm.isShowMore(record) ? _c("a-button", {
          attrs: {
            type: "primary"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("更多操作")) + " "), _c("a-icon", {
          attrs: {
            type: "down"
          }
        })], 1) : _vm._e()], 1)];
      }
    }])
  }, [_vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), _c("template", {
    slot: "customTitle"
  }, [_vm._v(_vm._s(_vm.$t("操作")) + " "), _c("a-icon", {
    staticClass: "setting",
    attrs: {
      type: "setting"
    },
    on: {
      click: _vm.settingColumn
    }
  })], 1)], 2), _c("tag-model", {
    attrs: {
      dialogVisible: _vm.tagShow,
      tagData: _vm.tagData,
      tagList: _vm.tagList,
      format: "second"
    },
    on: {
      cancel: function ($event) {
        _vm.tagShow = false;
      },
      ok: _vm.tagOk
    }
  }), _c("select-show-column", {
    ref: "selectShowColumn",
    attrs: {
      page: "policy"
    },
    on: {
      refreshList: _vm.searchFun
    }
  }), _c("a-modal", {
    staticClass: "reduce-modal",
    attrs: {
      title: _vm.$t("选择数据存放方式"),
      visible: _vm.showVisible,
      width: 700,
      maskClosable: false
    },
    on: {
      cancel: _vm.close,
      ok: _vm.okSubmit
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.form1,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      rules: _vm.rules
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: "20"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: "保单号",
      prop: "dataId"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: "请输入保单号"
    },
    model: {
      value: _vm.form1.dataId,
      callback: function ($$v) {
        _vm.$set(_vm.form1, "dataId", $$v);
      },
      expression: "form1.dataId"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };